import React from 'react';
import { Grid } from '@mui/material';
import getBaseEditor, { CommandPanels } from '../../BaseEditor';

const editorRenderer = (getControl) => (
  <Grid container spacing={2}>
    <Grid item sm={6}>
      {getControl('street')}
    </Grid>
    <Grid item sm={6}>
      {getControl('number')}
    </Grid>
  </Grid>
);

export default getBaseEditor(editorRenderer, '/api/catalog/houses/', CommandPanels.catCommandPanel);
